export default __webpack_public_path__ + "static/media/aws-account_card.dc492458.svg";